import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import '../index.css'
import {Chrono} from "react-chrono/dist/react-chrono";


type historyProps = {
    historyList : any
};


export default class CompanyHistory extends React.Component<historyProps> {

    render()
    {
        return (

            <div style={{ width: '100%', height: '100%' }}>
                <Chrono cardHeight={450} items={this.props.historyList} hideControls={true} disableNavOnKey={true} mode="VERTICAL" />
            </div>



        );

    }
}